<template>
  <div v-if="route.meta.showTabBar" :class="`tab-bar ${isIphoneX ? 'iphone-x' : ''}`">
    <template v-for="(item, index) in tabList" :key="index">
      <ThemeTabbar>
        <ThemeTabbarItem
          :active="currentPath.indexOf(item.key) > -1"
          :icon="item.iconPath"
          class="tab-item"
          :class="{ active: currentPath.indexOf(item.key) > -1 }"
          @click="handleChangeTab(item)"
          :data-jt-sender="
            JSON.stringify({
              event_type: 'click',
              block_desc: item.enterBtnTargetPath,
              button_desc: 'enter_btn',
              parameters: {},
            })
          "
        >
          <div class="tab-text">{{ item.name }}</div>
        </ThemeTabbarItem>
      </ThemeTabbar>
    </template>
  </div>
</template>

<script setup lang="ts" name="customerManager">
  import { commonApi } from '@shared/apis';
  import { ThemeTabbar, ThemeTabbarItem } from '@shared/components/theme-components';
  import { useThemeConfig } from '@shared/components/theme-components/use-theme-config';
  import { STATION_SHOW_TAB_WHITE_LIST } from '@shared/config';
  import { useDefaultLink } from '@shared/hooks';
  import { useGlobalStore, useAppPagePaths } from '@shared/store';
  import { isIphonex, searchToJson, withCurrentCorpIdStaffIdPath } from '@shared/utils';
  import _ from 'lodash';
  import { onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';

  const { toPath } = useDefaultLink();
  const appPagePaths = useAppPagePaths();
  // is

  const isIphoneX = isIphonex();
  //tab 主题色
  const { tabs: tabsTheme = {} } = useThemeConfig();

  const route = useRoute();
  const tabList = ref([]);
  const currentPath = window.location.pathname;
  onMounted(() => {
    handleTabbarTab();
    // tips: 设计提供的是双色图标，需要修改为主题色
    setTimeout(() => {
      tabList.value?.forEach((tabItem) => {
        const dom = document.getElementById(tabItem.activeIconPath);
        dom?.childNodes.forEach(($path) => {
          $path.setAttribute('fill', tabsTheme.activeTitleColor);
        });
      });
    }, 100);
  });
  const entrySearchObj = searchToJson();

  // 小站tab设置
  const getTabList = () => {
    const tabList = [
      {
        name: '首页',
        path: 'app://caizhi_webapp/home',
        key: '/caizhi_webapp/home',
        iconPath: 'czhome-home',
        activeIconPath: 'czhome-home-active',
        enterBtnTargetPath: 'home',
        menuType: 10,
      },
      {
        name: '经营',
        path: '/discovery',
        key: '/discovery',
        iconPath: 'czmoren41',
        activeIconPath: 'czgaoliang11',
        enterBtnTargetPath: 'discovery',
        menuType: 30,
      },
      {
        name: '财富',
        path: '/marketingWealth/home',
        key: '/marketingWealth/home',
        iconPath: 'czmoren31',
        activeIconPath: 'czgaoliang21',
        enterBtnTargetPath: 'marketingWealth',
        menuType: 20,
      },
      {
        name: '客户',
        path: '/customerManage',
        key: '/customerManage',
        iconPath: 'czhome-customer',
        activeIconPath: 'czhome-customer-active',
        enterBtnTargetPath: 'customerManagerHome',
        menuType: 40,
      },
      {
        name: STATION_SHOW_TAB_WHITE_LIST.includes(entrySearchObj.currentCorpId) ? '云工作室' : '我的',
        path: '/managerStation',
        key: '/managerStation',
        iconPath: 'czhome-station',
        activeIconPath: 'czhome-station-active',
        enterBtnTargetPath: 'managerStation',
        menuType: 50,
      },
    ];

    return tabList;
  };

  // 主站菜单tab处理
  const handleTabbarTab = async () => {
    const { retdata = [] } = await commonApi.getInEffectedList();
    const existList = [] as any[];
    retdata.forEach((element) => {
      existList.push(element.menuType);
    });
    let newTabList = _.cloneDeep(getTabList());
    newTabList = newTabList.filter((item) => {
      return existList.includes(item.menuType);
    });
    const pathArr = [] as any[];
    newTabList.forEach((element) => {
      pathArr.push(element.path);
    });
    tabList.value = newTabList;
  };

  // 切换tabBar
  const handleChangeTab = (item: any) => {
    if (item.enterBtnTargetPath === route.name) return;
    // 首页与其它tab不属于同一个项目时,用location.href跳转
    if (
      item.path.includes('app://') === false &&
      appPagePaths.vuePagePaths?.[item.path] !== appPagePaths.vuePagePaths?.['/caizhi_webapp/home']
    ) {
      item.path = `app://caizhi_webapp${item.path}`;
    }

    toPath('replace', {
      path: `${item.path}`,
    });
  };
</script>

<style lang="less" scoped>
  #app {
    .main {
      &.show-tab-bar {
        box-sizing: border-box;
        height: 100%;
        // padding-bottom: 1rem;
        // overflow-y: scroll;
        overflow: hidden;
        background: #fff;

        &.iphone-x {
          padding-bottom: 1rem;
        }
      }
    }

    // tabBar
    .tab-bar {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background-color: #fff;

      &.iphone-x {
        padding-bottom: 0.4rem;
      }

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 0.02rem;
        content: '';
        background-color: #ebebeb;
        transform: scaleY(0.5);
      }

      .tab-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 1rem;

        &.active {
          :deep(.anticon) {
            transform-origin: center center;
            animation: changeBiger 0.5s;
          }
        }
      }

      .tab-icon {
        font-size: 0.42rem;
      }

      .tab-text {
        margin-top: 0.04rem;
        font-size: 0.22rem;
      }
    }
  }

  .am-toast.am-toast-nomask {
    transform: translateZ(10010px);
  }

  .modalWrap {
    z-index: 9999;
    transform: translateZ(9999px);
  }

  .protocolNav.am-modal.am-modal-transparent {
    display: flex;
    justify-content: center;
    padding: 0;

    .am-modal-content {
      border: 0;

      .am-modal-body {
        padding: 0.2rem 0.3rem;
        margin: 0;
        border: 0;
      }
    }
  }

  @keyframes changeBiger {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2, 1.2);
    }

    100% {
      transform: scale(1);
    }
  }
</style>
